/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Spacer, Text } from "@nordcloud/gnui";
import { ServicesForEnv } from "~/components/Runbook/NordcloudServices/ServicesForEnv";
import { Divider } from "~/components/Styled/Divider";
import { Application } from "~/models";

type Props = {
  application: Application;
};

function NordcloudServices({ application }: Props) {
  return (
    <Divider>
      <Spacer height="1rem" />
      <Text isTitle weight="medium">
        Services Provided by Nordcloud
      </Text>

      {application.environments.map((env) => (
        <ServicesForEnv key={env.id} environment={env} />
      ))}

      <Spacer height="1rem" />
    </Divider>
  );
}

export { NordcloudServices };
